export const SET_FETCHING = 'SET_FETCHING';

export const setFetching = value => ({
  type: SET_FETCHING,
  value
});